import React, {
  useEffect, memo,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isNil from 'lodash/isNil';
import {
  setPaymentMethods,
} from './paymentMethodsSlice';
import {
  useLazyGetMultiPaymentMethodTypesQuery,
} from '../../../../../store/services/common/payment/paymentApi';
import PaymentMethod from './components/PaymentMethod';

const MultiPaymentMethods = ({
  combineErrorCallback, errorCallback,
}) => {
  const dispatch = useDispatch();
  const [ getMultiPaymentMethodTypes ] = useLazyGetMultiPaymentMethodTypesQuery();

  const {
    paymentMethods: {
      availablePaymentMethodTypes,
    },
  } = useSelector(state => state.paymentMethods.entities);

  useEffect(() => {
    const service = isNil(combineErrorCallback)
      ? getMultiPaymentMethodTypes
      : combineErrorCallback(getMultiPaymentMethodTypes);
    service().then(({ data }) => {
      data && dispatch(setPaymentMethods(data));
    });
  }, [ dispatch, combineErrorCallback, getMultiPaymentMethodTypes ]);

  if (availablePaymentMethodTypes?.length > 0) {
    return (
      <div className="multi-payment-methods">
        <div className='methods-container'>
          <PaymentMethod errorCallback={errorCallback}/>
        </div>
      </div>
    );
  }
  return null;
};

export default memo(MultiPaymentMethods);
